<div class="space-y-6">
  @if (showBreadcrumb) {
    <div class="mb-4">
      <p-breadcrumb
        [model]="homologationBreadcrumbs()"
        styleClass="rounded-lg border border-gray-200 dark:border-gray-800"
      >
        <ng-template pTemplate="separator">
          <i class="pi pi-chevron-right text-primary-400 text-sm mx-2"></i>
        </ng-template>
        <ng-template let-item pTemplate="item">
          @if (item.routerLink && !item.disabled) {
            <a
              [routerLink]="item.routerLink"
              class="flex items-center text-primary-600 hover:text-primary-800 dark:hover:text-primary-500 dark:text-primary-300 transition-colors duration-200"
            >
              @if (item.icon) {
                <i [class]="item.icon + ' mr-2'"></i>
              }
              <span>{{ item.label }}</span>
            </a>
          } @else {
            <span class="flex items-center text-primary-600 dark:text-primary-300">
              @if (item.icon) {
                <i [class]="item.icon + ' mr-2'"></i>
              }
              <span class="font-medium">{{ item.label }}</span>
            </span>
          }
        </ng-template>
      </p-breadcrumb>
    </div>
  }

  <div
    class="rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900"
  >
    <div class="flex flex-col gap-4 p-4">
      <div
        class="flex flex-col gap-3 border-b border-gray-200 pb-4 dark:border-gray-700 md:flex-row md:items-start md:justify-between"
      >
        <div>
          @if (showTitle) {
            <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-100">
              {{ 'homologationModule.title' | translate }}
            </h2>
          }
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {{ 'homologationModule.subtitle' | translate }}
          </p>
        </div>
      </div>

      <div
        class="w-full md:w-auto rounded-lg border border-primary-200 bg-primary-50 px-4 py-3 text-xs leading-relaxed text-primary-700 dark:border-primary-700/40 dark:bg-primary-900/20 dark:text-primary-200"
      >
        <div class="flex items-start gap-2">
          <i class="pi pi-info-circle mt-0.5"></i>
          <span>{{ 'homologationModule.helper' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  @if (loading) {
    <div
      class="flex flex-col items-center rounded-xl border border-gray-200 py-14 dark:border-gray-700"
    >
      <p-progressSpinner
        [ariaLabel]="'homologationModule.loading' | translate"
        [style]="{ width: '50px', height: '50px' }"
      />
      <p class="mt-3 text-sm text-gray-500 dark:text-gray-400">
        {{ 'homologationModule.loading' | translate }}
      </p>
    </div>
  } @else {
    <div
      class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900"
    >
      <div
        class="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-5 py-3 dark:border-gray-700 dark:bg-gray-800/70"
      >
        <p class="text-xs text-gray-500 dark:text-gray-400">
          Mostrando
          <span class="font-semibold text-gray-900 dark:text-gray-100">
            {{ homologations.length }}
          </span>
          {{ homologations.length === 1 ? 'homologación' : 'homologaciones' }}
        </p>
      </div>
      <p-table
        (onPage)="onPageChange($event)"
        [currentPageReportTemplate]="
          'homologationModule.pagination'
            | translate
              : {
                  first: '{first}',
                  last: '{last}',
                  totalRecords: '{totalRecords}',
                }
        "
        [first]="first"
        [lazy]="true"
        [paginatorDropdownAppendTo]="'body'"
        [paginator]="true"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        [rows]="rows"
        [showCurrentPageReport]="true"
        [tableStyle]="{ 'min-width': '50rem' }"
        [totalRecords]="totalRecords"
        [value]="homologations"
        responsiveLayout="scroll"
      >
        <ng-template #caption>
          <div class="flex flex-col gap-3 md:flex-row md:items-center md:gap-4">
            <div class="relative w-full md:flex-1">
              <p-inputgroup>
                <p-inputGroupAddon>
                  <i class="pi pi-search"></i>
                </p-inputGroupAddon>
                <input
                  (input)="onSearchChange()"
                  [(ngModel)]="searchTerm"
                  [placeholder]="'homologationModule.searchPlaceholder' | translate"
                  pInputText
                />
                @if (searchTerm) {
                  <p-inputGroupAddon
                    (click)="onClearSearch()"
                    (keydown.enter)="onClearSearch()"
                    (keydown.space)="onClearSearch(); $event.preventDefault()"
                    class="cursor-pointer"
                    role="button"
                    tabindex="0"
                  >
                    <i class="pi pi-times text-gray-400"></i>
                  </p-inputGroupAddon>
                }
              </p-inputgroup>
            </div>
            <div class="flex flex-wrap items-center gap-2">
              <p-button
                (onClick)="onNewHomologation()"
                [label]="'homologationModule.actions.createHomologation' | translate"
                icon="pi pi-plus"
              />
              <p-button
                (onClick)="onRefresh()"
                [ariaLabel]="'homologationModule.actions.refresh' | translate"
                [label]="'homologationModule.actions.refresh' | translate"
                icon="pi pi-refresh"
                outlined
                severity="secondary"
              />
            </div>
          </div>
        </ng-template>
        <ng-template #header>
          <tr class="bg-gray-50 text-xs font-semibold uppercase tracking-wide dark:bg-gray-800/70">
            <th scope="col">{{ 'homologationModule.columns.name' | translate }}</th>
            <th class="w-[180px]" scope="col">
              {{ 'homologationModule.columns.rules' | translate }}
            </th>
            <th class="w-[220px]" scope="col">
              {{ 'homologationModule.columns.created' | translate }}
            </th>
            <th class="w-[170px] text-center" scope="col">
              {{ 'homologationModule.columns.actions' | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template let-h pTemplate="body">
          <tr class="align-top">
            <td>
              <span>
                {{ h.name }}
              </span>
            </td>

            <td>
              <p-tag
                [rounded]="true"
                [value]="getRulesLabel(h)"
                class="text-xs font-medium!"
                icon="pi pi-key"
              ></p-tag>
            </td>

            <td>
              <span
                class="inline-flex items-center gap-1.5 rounded-md border border-indigo-200 bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 dark:border-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300"
              >
                <i class="pi pi-calendar text-[10px]"></i>
                {{ h.created_at | date: 'short' }}
              </span>
            </td>

            <td>
              <div class="flex justify-center gap-2">
                <p-button
                  (onClick)="onView(h)"
                  [ariaLabel]="'homologationModule.actions.viewDetails' | translate"
                  [pTooltip]="'homologationModule.actions.viewDetails' | translate"
                  icon="pi pi-eye"
                  severity="secondary"
                  text
                  tooltipPosition="top"
                />
                <p-button
                  (onClick)="onEdit(h)"
                  [ariaLabel]="'homologationModule.actions.editHomologation' | translate"
                  [pTooltip]="'homologationModule.actions.editHomologation' | translate"
                  icon="pi pi-pencil"
                  severity="info"
                  text
                  tooltipPosition="top"
                />
                <p-button
                  (onClick)="onDelete(h)"
                  [ariaLabel]="'homologationModule.actions.deleteHomologation' | translate"
                  [pTooltip]="'homologationModule.actions.deleteHomologation' | translate"
                  icon="pi pi-trash"
                  severity="danger"
                  text
                  tooltipPosition="top"
                />
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="py-10 text-center" colspan="4">
              <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                <i class="pi pi-inbox text-3xl"></i>
                <span class="font-medium">{{ 'homologationModule.empty' | translate }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>

<p-confirmDialog />

<lib-homologation-form
  (cancelled)="onCancelHomologation()"
  (save)="onSaveHomologation($event)"
  [(visible)]="showFormModal"
  [homologation]="homologationToEdit"
  [readonly]="readonly"
/>
